import React from 'react'
import { connect } from 'react-redux'

import { updatePurchaseOrderNumber } from './paymentMethodActionCreators'

import { Fade } from '../../componentAnimations'

import PurchaseOrderFormGroup from './PurchaseOrderFormGroup'

const PurchaseOrderComponent = ({ poNumber, selected, onChange, label = 'Your Internal PO Number', placeholder = '' }) => (
  <Fade inProp={selected} >
    <PurchaseOrderFormGroup 
      poNumber={poNumber} 
      onChange={onChange} 
      label={label} 
      placeholder={placeholder} 
      />
  </Fade>
)

const mapStateToProps = (state, ownProps) => ({
  poNumber: state.entities.PaymentRecord.POValue || "",
  selected: state.entities.SelectedPaymentOptionId === state.constants.purchaseOrderPaymentId,
  ...ownProps
})

const mapDispatchToProps = dispatch => ({
  onChange: (e) => (e && e.target && dispatch(updatePurchaseOrderNumber(e.target.value)))
})

const PurchaseOrderComponentContainer = connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderComponent)

export default PurchaseOrderComponentContainer


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/PaymentMethod/PurchaseOrderComponent.jsx